<template>
    <div class="Home">
        <div style="height:100px"></div>
        <div class="content-wrapper">
          <img src="../../resources/images/about3.png" alt="关于我们">
          <img src="../../resources/images/about1.png" alt="关于我们">
          <img src="../../resources/images/about4.png" alt="关于我们">
          <img src="../../resources/images/about2.png" alt="关于我们">
        </div>
    </div>
</template>
<script>

export default {
  name: 'about',
  components: {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/About.vue